module.exports = __webpack_public_path__ + "img/空白（插图+静态文字）.539a69f9.jpg";